import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrandLockup, BrandMark } from "../components/Brand";
import { EqBars } from "../components/EqBars";
import { api } from "../lib/api";

export default function Landing() {
  const [stats, setStats] = useState({ songs: 15, idioms: 30, questions: 90 });

  useEffect(() => {
    // Best-effort: pull real counts. Data is locked so the visible numbers won't drift.
    api.get("/packs").then((r) => {
      const idioms = r.data.reduce((s, p) => s + (p.published_count || 0), 0);
      if (idioms > 0) setStats((prev) => ({ ...prev, idioms, questions: idioms * 3 }));
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen text-white relative overflow-hidden"
         style={{ background: "linear-gradient(180deg, #070B14 0%, #0B1020 100%)" }}>
      <div className="hero-spectrum absolute inset-0" aria-hidden />

      <header className="relative z-10 px-6 sm:px-10 py-6 flex items-center justify-between">
        <BrandLockup />
        <nav className="flex items-center gap-5 text-sm text-zinc-400">
          <Link to="/rehber" data-testid="nav-guide-link"
                className="hover:text-cyan-300 transition hidden sm:inline">Öğretmen Rehberi</Link>
          <Link to="/login" data-testid="teacher-login-link"
                className="hover:text-cyan-300 transition">Öğretmen Girişi →</Link>
        </nav>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-6 sm:px-10 pt-10 pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-cyan-400/20 bg-cyan-400/5 px-3 py-1 text-xs text-cyan-200/90">
            <BrandMark size={14} /> 9. ve 10. sınıflar için canlı sınıf oyunu
          </div>

          <h1 className="mt-8 font-heading font-bold leading-[0.98] tracking-tight text-6xl sm:text-7xl">
            <span className="block text-white">ŞARKI SÖYLEYEN</span>
            <span className="block font-literary italic text-cyan-300">Deyimler</span>
          </h1>

          <p className="mt-6 font-literary italic text-xl sm:text-2xl text-zinc-200/90 max-w-2xl">
            Şarkılardaki deyimleri keşfet, anlamlarını yakala, sınıfın zirvesine çık.
          </p>
          <p className="mt-3 text-zinc-400 text-sm">
            Dinle · Deyimi Yakala · Anlamını Keşfet
          </p>
        </div>

        {/* Split hero cards */}
        <div className="mt-14 grid md:grid-cols-2 gap-5">
          <Link
            to="/join"
            data-testid="student-cta"
            className="group relative overflow-hidden rounded-3xl border border-cyan-400/40 bg-gradient-to-br from-cyan-500/15 via-cyan-500/5 to-transparent p-8 sm:p-10 hover:border-cyan-300 hover:shadow-[0_0_80px_-20px_rgba(6,213,230,0.6)] transition"
          >
            <div className="absolute -top-6 -right-4 opacity-40 group-hover:opacity-70 transition"><EqBars playing /></div>
            <div className="text-xs font-heading tracking-[0.2em] text-cyan-200">ÖĞRENCİYİM</div>
            <div className="mt-3 font-heading text-4xl font-bold">🎧 Oyuna Katıl</div>
            <p className="mt-3 text-zinc-300 text-sm max-w-sm">
              Öğretmenin verdiği 6 haneli kodla saniyeler içinde katıl. Hesap gerekmez, telefonun yeter.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 text-cyan-200 font-heading text-sm group-hover:gap-4 transition-all">
              Başla <span aria-hidden>→</span>
            </div>
          </Link>

          <Link
            to="/login"
            data-testid="teacher-cta"
            className="group relative overflow-hidden rounded-3xl border border-violet-400/25 bg-gradient-to-br from-violet-500/10 via-transparent to-transparent p-8 sm:p-10 hover:border-violet-300/60 hover:shadow-[0_0_60px_-25px_rgba(167,139,250,0.55)] transition"
          >
            <div className="text-xs font-heading tracking-[0.2em] text-violet-200">ÖĞRETMENİM</div>
            <div className="mt-3 font-heading text-4xl font-bold">🎓 Canlı Oyun Başlat</div>
            <p className="mt-3 text-zinc-400 text-sm max-w-sm">
              Paketini seç, sınıf kodunu paylaş, sahneyi yönet. Ses yalnızca senin cihazında çalar.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 text-violet-200 font-heading text-sm group-hover:gap-4 transition-all">
              Giriş yap <span aria-hidden>→</span>
            </div>
          </Link>
        </div>

        {/* Stats */}
        <section className="mt-16 grid grid-cols-3 gap-3 sm:gap-5">
          <StatCard label="ŞARKI"  value={stats.songs}     accent="cyan"   testId="stat-songs" />
          <StatCard label="DEYİM"  value={stats.idioms}    accent="violet" testId="stat-idioms" />
          <StatCard label="SORU"   value={stats.questions} accent="gold"   testId="stat-questions" />
        </section>

        <div className="mt-10 flex flex-wrap items-center gap-3 text-xs text-zinc-500">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.02] px-3 py-1">
            🎧 Şarkıyı bir kez dinlet
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.02] px-3 py-1">
            💭 Anlamını keşfet
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.02] px-3 py-1">
            🧠 Bağlamı yakala
          </span>
        </div>

        {/* Teacher guide teaser */}
        <section className="mt-12 rounded-3xl border border-violet-400/20 bg-gradient-to-r from-violet-500/10 via-transparent to-transparent p-6 sm:p-8"
                 data-testid="landing-guide-teaser">
          <div className="flex items-start sm:items-center gap-4 flex-wrap">
            <div className="text-4xl">📘</div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-heading tracking-widest text-violet-200">ÖĞRETMEN REHBERİ</div>
              <div className="mt-1 font-heading text-2xl font-bold">Sınıfta 5 dakikada başla</div>
              <p className="mt-1 text-zinc-400 text-sm">Oyun kurma, sınıfa yansıtma, YouTube kontrolü, reconnect — hepsi tek sayfada.</p>
            </div>
            <Link to="/rehber" data-testid="landing-guide-cta"
                  className="rounded-full bg-white text-black font-heading font-bold px-5 py-2.5">
              Rehberi Aç →
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}

const ACCENTS = {
  cyan:   "border-cyan-400/25   from-cyan-500/10   text-cyan-200",
  violet: "border-violet-400/25 from-violet-500/10 text-violet-200",
  gold:   "border-amber-400/25  from-amber-500/10  text-amber-200",
};

function StatCard({ label, value, accent, testId }) {
  return (
    <div
      className={`relative rounded-2xl border ${ACCENTS[accent].split(" ")[0]} bg-gradient-to-br ${ACCENTS[accent].split(" ")[1]} via-transparent to-transparent p-5 sm:p-6 backdrop-blur-sm`}
      data-testid={testId}
    >
      <div className={`text-[10px] sm:text-xs font-heading tracking-[0.2em] ${ACCENTS[accent].split(" ")[2]}`}>{label}</div>
      <div className="mt-2 font-heading font-bold tabular-nums text-4xl sm:text-5xl">{value}</div>
    </div>
  );
}
